import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-levelofservice-edit-modal',
  templateUrl: './levelofservice-edit-modal.component.html',
  styleUrls: ['./levelofservice-edit-modal.component.css']
})
export class LevelofserviceEditModalComponent implements OnInit {
  @Input() levelOfService: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveLevelOfService(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
